export const ThresholdIndices = {
  RED: {index: 2, color: 'rgba(254, 66, 61, .8)' },
  YELLOW: {index: 1, color: 'rgba(250, 182, 89, .8)' },
  GREEN: {index: 0, color: 'rgba(77, 170, 99, .8)' }
}
